var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8163 10.3896C13.8163 12.0396 12.4829 13.3729 10.8329 13.3729C9.18294 13.3729 7.84961 12.0396 7.84961 10.3896C7.84961 8.73958 9.18294 7.40625 10.8329 7.40625C12.4829 7.40625 13.8163 8.73958 13.8163 10.3896Z",
    stroke: "#464953",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8319 17.2809C13.7736 17.2809 16.5152 15.5476 18.4236 12.5476C19.1736 11.3726 19.1736 9.39759 18.4236 8.22259C16.5152 5.22259 13.7736 3.48926 10.8319 3.48926C7.89023 3.48926 5.14857 5.22259 3.24023 8.22259C2.49023 9.39759 2.49023 11.3726 3.24023 12.5476C5.14857 15.5476 7.89023 17.2809 10.8319 17.2809Z",
    stroke: "#464953",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0712eaa15302f4c6a78b23c2e996d867.svg";
export { ForwardRef as ReactComponent };